import React from "react";

export default function BlockchainDevelopmentHero() {
  return (
    <>
      <section
        className="feature-section py_150"
        aria-label="Blockchain-Development-Company-Hero-Section-Image"
        style={{
          backgroundPosition: "50% 50%",
          backgroundSize: "cover",
          backgroundImage:
            "url(assets/img/blockchain-dev/Blockchain-Development-Company-Hero-Section-Image.jpg)",
        }}
      >
        <div className="auto-container">
          <div className="row align-items-center pb_100">
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="content-box mr_40">
                <div data-animation-box="true" className="sec-title mb_25">
                  <h2 className="text-white">Blockchain Development Company</h2>
                </div>
                <div className="text-box">
                  <p className="text-white fs-5">
                    With expertise in over 40 blockchain protocols, we’re
                    leading the way to a web3 future through our advanced
                    blockchain development services.
                  </p>
                </div>
              </div>
              <a href="/contact-us" className="theme-btn btn-one m_20">
                Schedule A Free Demo
              </a>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 image-column"></div>
          </div>
        </div>
      </section>
    </>
  );
}
